import { Container, Graphics } from 'pixi.js';

export interface SlotMachineFrameOptions {
  /** Width of the reel grid (excluding side padding). */
  innerWidth: number;
  /** Height of the reel grid (excluding top + bottom padding). */
  innerHeight: number;
  /** Padding on each side of the reel grid. */
  padSide: number;
  /** Padding above the reel grid. Asymmetric on purpose — needs to be large
   * enough to fit the HOLD pill that sits over each reel without clipping
   * into the rounded-corner stroke. */
  padTop: number;
  /** Padding below the reel grid. */
  padBottom: number;
  /** Stroke colour. Defaults to the original brand pink. */
  accentColor?: number;
  /** Fill colour. Defaults to the original deep purple. */
  fillColor?: number;
}

/**
 * The pink-stroked rounded rectangle that encloses the slot-machine reel
 * grid. Drawn in machine-local coordinates with origin at the top-left of
 * the reel grid; asymmetric top padding leaves clear space for HOLD pills
 * above each reel.
 *
 * <p>Owned by {@link ./SlotMachine SlotMachine}. Sized once at construction;
 * a re-skin (different colours, thicker stroke, etc.) replaces the whole
 * frame rather than mutating it.
 */
export class SlotMachineFrame extends Container {
  constructor(opts: SlotMachineFrameOptions) {
    super();
    const accent = opts.accentColor ?? 0xff6bd6;
    const fill = opts.fillColor ?? 0x1a0830;
    const g = new Graphics();
    g
      .roundRect(
        -opts.padSide,
        -opts.padTop,
        opts.innerWidth + opts.padSide * 2,
        opts.innerHeight + opts.padTop + opts.padBottom,
        16,
      )
      .fill({ color: fill, alpha: 0.85 })
      .stroke({ color: accent, alpha: 0.8, width: 3 });
    this.addChild(g);
  }
}
